import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * Archives a non-SCIM user in the caller's active org via the tRPC
 * `frontend.user.archiveUser` mutation. Server-side guards enforce
 * self-archive blocking, SCIM blocking, and status preconditions —
 * this hook just routes the call and invalidates the user list query
 * so the Settings → Users table reflects the new status without a
 * page reload.
 */
export const useArchiveUserTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...trpc.frontend.user.archiveUser.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.user.users.queryKey(),
        });
      },
    }),
  });

  return {
    archiveUser: (userId: string) => mutation.mutateAsync({ userId }),
    loading: mutation.isPending,
    error: mutation.error,
  };
};
